import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {assignGrants} from 'src/openapi/admin/apis/BulkAssignPresetGrantsApi';
import {useAppDispatch} from 'src/store/hooks';

import type {Error} from 'src/openapi/admin/models/Error';
import type {PresetRelation} from 'src/openapi/admin/models/PresetRelation';
import type {SuccessPayload} from 'src/typedef';

type ActionProps = {
    presetId: string,
    updateReason?: string,
};

export const useAssignGrantsToPreset = (grants: PresetRelation[]) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback(async (props?: ActionProps) => {
        if (!props?.presetId) {
            const payload: {success: false, error: true, data: Error} = {
                success: false,
                error: true,
                data: {message: 'Preset ID is required'},
            };
            return Promise.resolve({type: '', payload});
        }

        const {presetId, updateReason} = props;
        const assignGrantsResponse = await apiDispatch(assignGrants({
            presetGrantsRequest: {presetId, grants, updateReason},
        }));

        if (assignGrantsResponse.payload.success) {
            const payload: SuccessPayload<undefined> = {
                success: true,
                error: false,
                data: undefined,
            };
            return Promise.resolve({type: '', payload});
        } else {
            return Promise.resolve({type: '', payload: assignGrantsResponse.payload});
        }
    }, [grants, apiDispatch]);

    return useCommonEventHook({eventAction});
};
